import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { JourneySchoolReportData } from '@mira-avant/mtlibs';
import { NzButtonModule } from "ng-zorro-antd/button";
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
	selector: 'app-journey-school-report-summary',
	imports: [CommonModule, NzButtonModule, NzIconModule],
	standalone: true,
	templateUrl: './journey-school-report-summary.html',
	styleUrl: './journey-school-report-summary.scss',
})
export class JourneySchoolReportSummary {
	@Input('report') public report:JourneySchoolReportData | undefined;
}
